module.exports = __webpack_public_path__ + "static/media/U_nieakt.8a1bd0ea.svg";